import Header from '../../components/Header';
import Chart from '../../components/Chart';
import CurrencySelector from '../../components/CurrencySelector';

import RightContent from '../../components/RightContent';
import LeftContent from '../../components/LeftContent';

import './index.less';

const Index = () => {
  return (
    <div className="currency-layout-md">
      <div className="left-box">
        <Header />
        <CurrencySelector />
        <Chart />
        <div className="left-main-box">
          <LeftContent />
        </div>
      </div>
      <RightContent />
    </div>
  );
};

export default Index;
